export default __webpack_public_path__ + "static/media/promo_pasada-Monaco.4ab5cc51.webp";